import React from "react";
import { MdOutlineAdd } from "react-icons/md";

import styles from '../../styles/Components/Shared/FeaturedTable.module.css';

const FeaturedTable = ({
    tableName,
    subTitle,
    addButtonName,
    featuredData,
    FeaturedForm,
    handleSubmit,
    handleChangeData,
    setFeaturedData,
    expiredText,
    page_id,
    section_id,
    defaultFeatured = {},
    useLanguage,
    selectedLanguage,
    missingIndex,
    clearFeaturedRow,
    clear,
    maxRows,
    addedStyles,
    disableAdd,
    setSelectedContent,
    disabled,
}) => {

    const handleAddFeatured = () => {
        setFeaturedData(prevData => [
            ...prevData,
            {
                ...defaultFeatured,
                ...useLanguage && selectedLanguage ? { language_id: selectedLanguage.language_id } : {}
            },
        ])
    }

    const allowAddRow = ((!maxRows || (featuredData?.length < maxRows)) && !disableAdd) ? true : false;

    return (
        <div className={styles.featured_container} style={addedStyles ? addedStyles : {}}>

            <div className={styles.featured_header}>
                <div className={styles.featured_header_title_container}>
                    <p className={styles.featured_title}>{tableName}</p>
                    
                    {subTitle ? 
                        subTitle
                    : null}

                    {expiredText ? 
                        <p className={styles.featured_expired_text}><span>*</span> {expiredText}</p>
                    : null}
                </div>
                {allowAddRow ?
                    <button className={styles.featured_add_button} onClick={handleAddFeatured}>Add {addButtonName} <MdOutlineAdd size={20} color={'white'}/>     </button>
                : null}
            </div>

            <div className={styles.featured_content_section}>
                {featuredData?.length > 0 ?
                        featuredData.map((featured, i) => (
                            <FeaturedForm 
                                index={i} 
                                key={`featured-${i}`} 
                                featured={featured} 
                                handleChangeData={handleChangeData} 
                                page_id={page_id} 
                                section_id={section_id} 
                                featuredLength={featuredData.length}
                                missingData={missingIndex && missingIndex?.includes(i) ? true : false}
                                clearFeaturedRow={clearFeaturedRow}
                                clear={clear}
                                setSelectedContent={setSelectedContent}
                                disabled={disabled}
                                /> 
                        ))
                : null}

                <div className={styles.featured_button_wrapper}>
                    
                    <div className={styles.featured_button_container}>
                        {allowAddRow ?
                            <button className={styles.featured_add_button} onClick={handleAddFeatured}>Add {addButtonName} <MdOutlineAdd size={20} color={'white'}/></button>
                        : null}
                        <button className={`${styles.featured_submit_button} ${disabled ? 'button_disabled' : ''}`} disabled={disabled} onClick={handleSubmit}>Submit</button>
                    </div>
                </div>
            </div>

        </div>
    );
};

export default FeaturedTable;
